import { SB_CACHE_VERSION_TAG } from "@/constants/cacheTags";

export function getNextCachingParams(
  version: "draft" | "published",
  revalidate?: number,
) {
  return {
    next: { tags: [SB_CACHE_VERSION_TAG], revalidate },
    cache: version === "published" ? "default" : "no-store",
  } satisfies RequestInit;
}
